<template>
  <DialogClose
    data-slot="dialog-close"
    class="opacity-muted absolute top-4 right-4 cursor-pointer rounded-full ring-offset-2 transition-opacity hover:opacity-100 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
  >
    <Icon name="lucide:x" />
    <span class="sr-only">Close</span>
  </DialogClose>
</template>

<script setup lang="ts">
import { DialogClose } from "reka-ui";
</script>
